import React from "react";
import { getTranslation } from "./i18n";

const WinOverlay = ({ winner, onRestart, onMenu, locale }) => {
    return (
        <div className="h-screen w-screen z-50 absolute top-0 left-0 flex items-center justify-center bg-gradient">
            <div className="p-8 text-center flex flex-col gap-4 w-full max-w-xl">
                <p className="text-3xl pb-6">
                    {winner === "r" ? getTranslation(locale, "win") : getTranslation(locale, "lose")}
                </p>
                <button className="btn btn-primary justify-between btn-lg" onClick={onRestart}>{getTranslation(locale, "reset")}</button>
                <button className="btn btn-primary justify-between btn-lg" onClick={onMenu}>{getTranslation(locale, "quit")}</button>
            </div>
        </div>
    );
};

export default WinOverlay;



// WEBPACK FOOTER //
// ./src/WinOverlay.js